import { Component, inject, Input } from '@angular/core';
import { KeycloakWrapperService } from '@app/finxone-web-frontend/app/lib/services/keycloak-wrapper-service/keycloak-wrapper.service';
import { baseCssConfigStyle } from '@finxone-platform/shared/sys-config-types';
import { PageConfigurationProvider } from '../../../zones/page-configuration.provider';
import { SocketService } from '@app/finxone-web-frontend/app/lib/services/socket-service/socket-service.service';
import { logoutAndDisconnectWebSockets } from '@app/finxone-web-frontend/app/Modules/shared/components-library/logout/logout.utils';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent {
  @Input() logoutWidgetData: {
    title: string;
    icon: string | undefined;
  };
  @Input() contentStyle: baseCssConfigStyle;
  @Input() textContentStyle: baseCssConfigStyle;
  @Input() public iconStyle?: baseCssConfigStyle;
  @Input() public iconSize?: baseCssConfigStyle;
  @Input() globalStylingClass = '';
  @Input() isAllowedGlobalStyling = false;

  private readonly socketService = inject(SocketService);
  private readonly keycloakService = inject(KeycloakWrapperService);
  public readonly pageConfig = inject(PageConfigurationProvider);

  logout(): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flutterWebView = (window as any).flutter_inappwebview;

    if (flutterWebView) {
      flutterWebView
        .callHandler('setRememberMe', [false])
        .then(() => {
          logoutAndDisconnectWebSockets(this.socketService, this.keycloakService);
        })
        .catch(() => {
          console.error('Failed to set rememberMe to false');
          logoutAndDisconnectWebSockets(this.socketService, this.keycloakService);
        });
    } else {
      logoutAndDisconnectWebSockets(this.socketService, this.keycloakService);
    }
  }

  get buttonStyles() {
    return this.isAllowedGlobalStyling ? {} : { ...this.textContentStyle, ...this.contentStyle };
  }
}
